import * as React from 'react';
import {useStyletron} from "baseui";
import {Info} from "lucide-react";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../ui/tooltip";

export function InfoTooltip() {
    const [, theme] = useStyletron();
    
    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div className="flex items-center cursor-pointer">
                        <Info size={16} color={theme.colors.contentSecondary} />
                    </div>
                </TooltipTrigger>
                <TooltipContent 
                    side="top" 
                    className="max-w-[300px]"
                >
                    <p className="m-0">While on a trial you can provide payment details to ensure a seamless transition when the trial ends. You will not be charged until the trial has ended.</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
